import * as React from 'react';
import { useState, useEffect, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import {Toolbar, Container, Button } from '@mui/material'
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Avatar from '@mui/material/Avatar';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import NotificationsIcon from '@mui/icons-material/Notifications';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import { mainListItems, secondaryListItems } from './drawerListItems';

import ProjectDescription from './ProjectDescription'
import ProjectList from './ProjectList'
import ProfileMenu from './ProfileMenu'
import LoginLogoutMenu from './LoginLogoutMenu'

import Copyright from './Copyright'
import Welcome from './Welcome'

import DashboardView from './DashboardView'
import TrendView from './TrendView'
import TableView from './TableView'
import RecipeView from './RecipeView'
import BatchData from './BatchData'
import AlarmView from './AlarmView'
import ReportView from './ReportView'
import ReportViewComplience from './ReportViewComplience'
import UserManagement from './UserManagement'
import AuditTrailView from './AuditTrailView'
import DataBackup from './DataBackup'
import DataRestore from './DataRestore'
import DataEdit from './DataEdit'
import Email from './Email'
import SMS from './SMS'

import ConfigurationView from './ConfigurationView'
import FTPServer from './FTPServer'
import FTPClient from './FTPClient'
import FileTransfer from './FileTransfer'
import License from './License'
import Help from './Help'
import Documents from './Documents'

import DashboardIcon from '@mui/icons-material/Dashboard';
import TableViewIcon from '@mui/icons-material/TableView';
import LibraryBooksRoundedIcon from '@mui/icons-material/LibraryBooksRounded';
import BatchPredictionIcon from '@mui/icons-material/BatchPrediction';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import TimelineIcon from '@mui/icons-material/Timeline';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AuditTrail from "../assets/AuditTrail.png";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import RestoreIcon from '@mui/icons-material/Restore';
import MailIcon from '@mui/icons-material/Mail';
import SmsIcon from '@mui/icons-material/Sms';

import SettingsIcon from '@mui/icons-material/Settings';
import BackupIcon from '@mui/icons-material/Backup';
import FTPServerIcon from "../assets/ftpserver.png";
import FTPClientIcon from "../assets/ftpclient.png";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import InstallDesktopIcon from '@mui/icons-material/InstallDesktop';
import EngineeringIcon from '@mui/icons-material/Engineering';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import StickyFooter from './Footer'
import Draggable from "react-draggable";
import {Resizable} from "re-resizable";
import { useDispatch, useSelector } from "react-redux";

import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';

import SaveAsIcon from '@mui/icons-material/SaveAs';

import Tooltip from '@mui/material/Tooltip';
import IdleTimeout from './IdleTimeout'; // Import the IdleTimeout component


import ConfigurationViewService from '../services/configurationview.service.js';
import AlarmViewService from '../services/alarmview.service';
import { logout } from "../slices/auth";
import EventBus from "../common/EventBus";


import './NotificationIcon.css'; // Import CSS file with animation class
//import { downloadProfilePhoto, uploadProfilePhoto, changeuserinfo, changepassword } from "../slices/auth";
import AuthService from "../services/auth.service";
import DateTimeDisplay from './DateTimeDisplay.js';




const drawerWidth = 240;
//const minimizedWidth = 60;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open, hidden }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open, hidden}) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export default function Layout() {
  const initialLayoutConfigData = [{

    SrNo:'1',
    ComponentName:'TopBar',
    ComponentStatus: 'Enabled',
    ComponentDescription: 'TopBar',
    Option: 2,
    backgroundColor: '#00aeef',
    fontWeight: 'normal',
    fontSize: '16 px',
    textAlign: 'center',
    textColor: 'white',
    overflow: 'auto',
    minHeight: '0vh',
    minWidth: '0vw',
    maxHeight: '1vh',
    maxWidth: '1vw',
    ml: 0,
    mr: 0,
    mt: 0,
    mb: 0,
         
  },
  {

    SrNo:'2',
    ComponentName:'Logo',
    ComponentStatus: 'Enabled',
    ComponentDescription: 'Logo',
    Option: 2,
    backgroundColor: '#00aeef',
    fontWeight: 'normal',
    fontSize: '16 px',
    textAlign: 'center',
    textColor: 'white',
    overflow: 'auto',
    minHeight: '50',
    minWidth: '156',
    maxHeight: '100',
    maxWidth: '256',
    ml: 0,
    mr: 0,
    mt: 0,
    mb: 0,
         
  },
  {

    SrNo:'3',
    ComponentName:'ProjectDescription',
    ComponentStatus: 'Enabled',
    ComponentDescription: 'ProjectDescription',
    Option: 2,
    backgroundColor: '1976d2',
    fontWeight: '700',
    fontSize: '22',
    textAlign: 'center',
    textColor: 'white',
    overflow: 'auto',
    minHeight: '5vh',
    minWidth: '50vw',
    maxHeight: '100',
    maxWidth: '256',
    ml: 0,
    mr: 0,
    mt: 0,
    mb: 0,
         
  },
  {

    SrNo:'4',
    ComponentName:'ComFailIcon',
    ComponentStatus: 'Enabled',
    ComponentDescription: 'ComFailIcon',
    Option: 2,
    backgroundColor: '1976d2',
    fontWeight: '700',
    fontSize: '22',
    textAlign: 'center',
    textColor: 'white',
    overflow: 'auto',
    minHeight: '5vh',
    minWidth: '50vw',
    maxHeight: '100',
    maxWidth: '256',
    ml: 0,
    mr: 0,
    mt: 0,
    mb: 0,
         
  },
  {

    SrNo:'5',
    ComponentName:'AlarmIcon',
    ComponentStatus: 'Enabled',
    ComponentDescription: 'AlarmIcon',
    Option: 2,
    backgroundColor: '1976d2',
    fontWeight: '700',
    fontSize: '22',
    textAlign: 'center',
    textColor: 'white',
    overflow: 'auto',
    minHeight: '5vh',
    minWidth: '50vw',
    maxHeight: '100',
    maxWidth: '256',
    ml: 0,
    mr: 0,
    mt: 0,
    mb: 0,
         
  },
  {

    SrNo:'6',
    ComponentName:'UserIcon',
    ComponentStatus: 'Enabled',
    ComponentDescription: 'UserIcon',
    Option: 2,
    backgroundColor: '1976d2',
    fontWeight: '700',
    fontSize: '22',
    textAlign: 'center',
    textColor: 'white',
    overflow: 'auto',
    minHeight: '5vh',
    minWidth: '50vw',
    maxHeight: '100',
    maxWidth: '256',
    ml: 0,
    mr: 0,
    mt: 0,
    mb: 0,
         
  },
  {

    SrNo:'7',
    ComponentName:'CompanyName',
    ComponentStatus: 'Enabled',
    ComponentDescription: 'CompanyName',
    Option: 2,
    backgroundColor: '1976d2',
    fontWeight: '700',
    fontSize: '22',
    textAlign: 'center',
    textColor: 'white',
    overflow: 'auto',
    minHeight: '5vh',
    minWidth: '50vw',
    maxHeight: '100',
    maxWidth: '256',
    ml: 0,
    mr: 0,
    mt: 0,
    mb: 0,
         
  },
  {

    SrNo:'8',
    ComponentName:'BackgroundImage',
    ComponentStatus: 'Enabled',
    ComponentDescription: 'BackgroundImage',
    Option: 2,
    backgroundColor: '1976d2',
    fontWeight: '700',
    fontSize: '22',
    textAlign: 'center',
    textColor: 'white',
    overflow: 'auto',
    minHeight: '5vh',
    minWidth: '50vw',
    maxHeight: '100',
    maxWidth: '256',
    ml: 0,
    mr: 0,
    mt: 0,
    mb: 0,
         
  },
{

    SrNo:'9',
    ComponentName:'DateTimeDisply',
    ComponentStatus: 'Disabled',
    ComponentDescription: 'BackgroundImage',
    Option: 2,
    backgroundColor: '1976d2',
    fontWeight: '700',
    fontSize: '22',
    textAlign: 'center',
    textColor: 'white',
    overflow: 'auto',
    minHeight: '5vh',
    minWidth: '50vw',
    maxHeight: '100',
    maxWidth: '256',
    ml: 0,
    mr: 0,
    mt: 0,
    mb: 0,
         
  },
{

    SrNo:'10',
    ComponentName:'PowerOnScreen',
    ComponentStatus: 'Disabled',
    ComponentDescription: 'BackgroundImage',
    Option: 2,
    backgroundColor: '1976d2',
    fontWeight: '700',
    fontSize: '22',
    textAlign: 'center',
    textColor: 'white',
    overflow: 'auto',
    minHeight: '5vh',
    minWidth: '50vw',
    maxHeight: '100',
    maxWidth: '256',
    ml: 0,
    mr: 0,
    mt: 0,
    mb: 0,
         
  }];
  const [layoutConfigData, setLayoutConfigData] = useState(initialLayoutConfigData);
  const [projectDescrprops, setProjectDescrprops] = useState(initialLayoutConfigData[2]);

  //Get license details from backend
  const [licenseType, setLicenseType] = useState("Demonstration");
  const [licenseStatus, setLicenseStatus] = useState(false)
  const [keyStatus, setKeyStatus] = useState("Invalid License Key")

  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = useState(false); // Example width
  const handleToggleMinimize = () => {
    
      if(open === false){
        setHidden(false)
        setOpen(true)
      }else{
        setOpen(false)
      }
    
    //setOpen(!open);
    
  };


  const toggleDrawer = () => {
    //console.log(open)
    if(open ===  true){
      setOpen(false)
      
    }else{
      if(hidden === false){
        setHidden(true)
      }else{
        setHidden(false)
      }
    }
  };


  // get projname from ProjectList component ans set it to the setSelecetdProject
 //Hence we can pass it to the ProjectDescription component
  const { user } = useSelector((state) => state.auth);
  //console.log(user)
  
  const [selecetdProject, setSelecetdProject] = useState(user?.selectedproject || null);
  const[loginScreenStatus, setLoginScreenStatus] = useState(user?.TaskStatus || null);
  const[reloadPage, setReloadPage] = useState('false');
  const projName = (newData) => {setSelecetdProject(newData);};
  //console.log(user.selectedproject, selecetdProject);

  // Define your list of components
  const componentList = [
    <Welcome key="A" />,
    <DashboardView key="B" />,
    <TableView key="C" />,
    <TrendView key="D" />,
    <AlarmView key="E" />,
    <ReportView key="F" />,
    <ReportViewComplience key="G"/>,
    <UserManagement key="H" />,
    <AuditTrailView key="I" />,
    <DataBackup key="J" />,
    <DataRestore key="K" />,
    <DataEdit key="L" />,
    <Email key="M" />,
    <SMS key="N" />,
    
    <ConfigurationView key="O" />,
    <FTPServer key="P" />,
    <FTPClient key="Q" />,
    <FileTransfer key="R" />,
    <License key="S" />,
    <Help key="T" />,
    <Help key="U" />,
    <Help key="V" />,
    <Documents key="W" />,
    <RecipeView key="X" />,
    <BatchData key="Y" />,
  ];

  // State to store the selected component
  const [selectedComponent, setSelectedComponent] = useState(componentList[2]);

  //Get License Details
  useEffect( ()=>{
    async function getLicenseDetails()  {
      try {

        //let dashboardName = "LicenseConfig";
        //const response = await ConfigurationViewService.getAllRowsData(dashboardName);
        let dashboardName = "LicenseConfig";
        let columnsToRetrieve = ["LicenseStatus", "LicenseType"];
        let columnToFilter ="ProjectName";
        let valueToMatch = "Project1-1"

        
        const response = await ConfigurationViewService.getMultiColumnsRows(dashboardName, columnsToRetrieve, columnToFilter, valueToMatch );

        if (response.data[0] !== null && response.data[0] !== undefined) {
          //console.log(response.data[0]);
          
          setLicenseType(response.data[0].LicenseType);
          setKeyStatus(response.data[0].LicenseStatus);
          if(response.data[0].LicenseStatus === "Active" 
            || response.data[0].LicenseStatus === "Invalid License Key"
            || response.data[0].LicenseStatus === "License Service Detection Failed"
            )
          {
            setLicenseStatus(true)
          }else{
            setLicenseStatus(false)
          }
        }

        
        
      } catch (error) {
        console.log(error);

      }
    }

      getLicenseDetails();

    

  }, [])
 
  //Get configuration of the Layout
  useEffect(() => {
      if (licenseStatus === null || licenseStatus === undefined) { return; }
      async function getColumnData() {
          try {
              const dashboardName = "LayoutConfig";
              const columnName = "WidgetName";
              const columnValue = "LayoutConfig";
              const response = await ConfigurationViewService.getColumnData( dashboardName, columnName, columnValue );
              setLayoutConfigData(response?.data ?? []);
              setProjectDescrprops(response?.data?.[2]);

              let option = 2;
              try {
                  const powerOnScreen = Array.isArray(response?.data) ? response.data.find( x => x?.ComponentName === "PowerOnScreen" ) : null;

                  const optionValue = Number(powerOnScreen?.Option);

                  if (Number.isFinite(optionValue)) { option = optionValue; }
              } catch (error) {
                  console.error( "Error reading PowerOnScreen option:", error );
                  option = 2;
              }

              setSelectedComponent( licenseStatus ? ( componentList?.[option] ?? componentList?.[0] ) : componentList?.[0] );
          } catch (error) {
              console.log(error);
              // If the API itself fails, use option 2
              setSelectedComponent( licenseStatus ? componentList?.[2] : componentList?.[0] );
          }
      }

      getColumnData();
  }, [licenseStatus]);

  
  // Function to handle component selection
  const handleComponentSelection = (component) => {
  setSelectedComponent(component);
  };
  
  function ComponentA() {
    return <p>Component A Content</p>;
  }

  const [liveAlarmCount, setLiveAlarmCount] = React.useState(0)
  // Get the Live Alarm count
  useEffect(() => {
    const intervalId = setInterval(() => {
    async function getLiveAlarmCount()  {
      try {
          let dashboardName = "AlarmViewData";
          let columnToFilter ="AlarmDuration";
          let valueToMatch = 0

          const response = await AlarmViewService.getDocCount(dashboardName, columnToFilter, valueToMatch );
          //console.log(response.data, typeof(response.data))
          if (response){
            
            let LiveAlarmCount = response.data;
            if (typeof LiveAlarmCount === 'number'){
              setLiveAlarmCount(response.data);
            }else{
              setLiveAlarmCount("Er");
            }
            
          }
        }catch(error){
          setLiveAlarmCount("Err");
          //console.log(error);

      }
    };
    getLiveAlarmCount();

  }, 1000);
  // Clear the interval when the component unmounts
  return () => clearInterval(intervalId);
    

  }, []);

  //Handle Autologout
  //const timeOutSP = parseInt(user.UserAccess[13].Value) * 60000
  const timeOutSP = user && user.UserAccess && user.UserAccess[13] 
  ? parseInt(user.UserAccess[13].Value) * 60000 
  : 60000 ; // Or set a default value (e.g., 0 or 10 minutes) if `null`
  //console.log(user.role)
  //console.log(timeOutSP)
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const logOut = useCallback(() => {
    
    dispatch(logout());
    //console.log("Logout button was pressed")
    
  }, [dispatch]);

  useEffect(() => {
    

    EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, [logOut]);

  const handleLogout = () => {
    if (user.email !== "visitor@gmail.com"){
      navigate("/login");
      window.location.reload();
      logOut();
    }
  };
///////////////////////////

  let shaking = true;
  const iconClassName = shaking ? 'shake-animation' : '';
  

  const isDashboardViewAccess = user && user.UserAccess && user.UserAccess[6] && user.UserAccess[6].Enable === "Enabled" && user.UserAccess[6].Options 
  ? user.UserAccess[6].Options.includes(user.role)
  : false; // Default to false if user or the necessary properties are null or undefined

  const isTableViewAccess = user && user.UserAccess && user.UserAccess[7] && user.UserAccess[7].Enable === "Enabled" && user.UserAccess[7].Options 
  ? user.UserAccess[7].Options.includes(user.role)
  : false;

  const isRecipeViewAccess = user && user.UserAccess && user.UserAccess[54] && user.UserAccess[54].Enable === "Enabled" && user.UserAccess[54].Options 
  ? user.UserAccess[54].Options.includes(user.role)
  : false;

  const isBatchDataAccess = user && user.UserAccess && user.UserAccess[55] && user.UserAccess[55].Enable === "Enabled" && user.UserAccess[55].Options 
  ? user.UserAccess[55].Options.includes(user.role)
  : false;

  const isTrendViewAccess = user && user.UserAccess && user.UserAccess[8] && user.UserAccess[8].Enable === "Enabled" && user.UserAccess[8].Options 
    ? user.UserAccess[8].Options.includes(user.role)
    : false;

  const isAlarmViewAccess = user && user.UserAccess && user.UserAccess[9] && user.UserAccess[9].Enable === "Enabled" && user.UserAccess[9].Options 
    ? user.UserAccess[9].Options.includes(user.role)
    : false;

  const isReportViewAccess = user && user.UserAccess && user.UserAccess[10] && user.UserAccess[10].Enable === "Enabled" && user.UserAccess[10].Options 
    ? user.UserAccess[10].Options.includes(user.role)
    : false;

  const isAuditTrailViewAccess = user && user.UserAccess && user.UserAccess[11] && user.UserAccess[11].Enable === "Enabled" && user.UserAccess[11].Options 
    ? user.UserAccess[11].Options.includes(user.role)
    : false;

  const isUserMgmtViewAccess = user && user.UserAccess && user.UserAccess[12] && user.UserAccess[12].Enable === "Enabled" && user.UserAccess[12].Options 
  ? user.UserAccess[12].Options.includes(user.role)
  : false;

  const isFtpServerViewAccess = user && user.UserAccess && user.UserAccess[43] && user.UserAccess[43].Enable === "Enabled" && user.UserAccess[43].Options 
  ? user.UserAccess[43].Options.includes(user.role)
  : false;

  const isFtpClientViewAccess = user && user.UserAccess && user.UserAccess[44] && user.UserAccess[44].Enable === "Enabled" && user.UserAccess[44].Options 
  ? user.UserAccess[44].Options.includes(user.role)
  : false;

  const isEmailViewAccess = user && user.UserAccess && user.UserAccess[45] && user.UserAccess[45].Enable === "Enabled" && user.UserAccess[45].Options 
  ? user.UserAccess[45].Options.includes(user.role)
  : false;

  const isSMSViewAccess = user && user.UserAccess && user.UserAccess[46] && user.UserAccess[46].Enable === "Enabled" && user.UserAccess[46].Options 
  ? user.UserAccess[46].Options.includes(user.role)
  : false;

  const isDataBackupViewAccess = user && user.UserAccess && user.UserAccess[47] && user.UserAccess[47].Enable === "Enabled" && user.UserAccess[47].Options 
  ? user.UserAccess[47].Options.includes(user.role)
  : false;

  const isDataRestoreViewAccess = user && user.UserAccess && user.UserAccess[48] && user.UserAccess[48].Enable === "Enabled" && user.UserAccess[48].Options 
  ? user.UserAccess[48].Options.includes(user.role)
  : false;

  const isHistDataEditorViewAccess = user && user.UserAccess && user.UserAccess[49] && user.UserAccess[49].Enable === "Enabled" && user.UserAccess[49].Options 
  ? user.UserAccess[49].Options.includes(user.role)
  : false;

  const isAppDataEditorViewAccess = user && user.UserAccess && user.UserAccess[50] && user.UserAccess[50].Enable === "Enabled" && user.UserAccess[50].Options 
  ? user.UserAccess[50].Options.includes(user.role)
  : false;

  const isLicenseConfiguratorViewAccess = user && user.UserAccess && user.UserAccess[51] && user.UserAccess[51].Enable === "Enabled" && user.UserAccess[51].Options 
  ? user.UserAccess[51].Options.includes(user.role)
  : false;

  const isReportViewWithReviewOption = user && user.UserAccess && user.UserAccess[53] && user.UserAccess[53].Enable === "Enabled" && user.UserAccess[53].Options 
    ? user.UserAccess[53].Options.includes(user.role)
    : false;


  // Get the logo from backend & stored as Logo
  const [logo, setLogo] = useState(null);
  const handleLogoImageDownload= async (Logo) => {
    try {

      const response = await AuthService.downloadProfilePhoto(Logo);

      //console.log(response.data);
      const base64 = btoa(new Uint8Array(response.data)
        .reduce((data, byte) => data + String.fromCharCode(byte),
         ''));
      setLogo('data:image/jpeg; base64,' + base64);
     
    } catch (error) {
      console.log(error);
      
    }
  }

  useEffect(() => {handleLogoImageDownload('Logo');}, []);


  // if defaultUser or user data is not received from backend then reload the page
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // If user is null, we want to check periodically for the user data
    const intervalId = setInterval(() => {
      //console.log(user)
      if (user !== null) {
        setLoading(false); // Set loading to false once user data is available
        clearInterval(intervalId); // Stop checking after user is fetched
      }else{
        //console.log('User data not found, triggering page reload...');
        window.location.reload(); // Reload the page if user data is not found
      }
    }, 1000); // Check every 5 seconds

    // Cleanup the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [user]);

  if (loading === true) {
    return <div>Loading...</div>;
  }

  return (
    <ThemeProvider theme={defaultTheme}>
      <Box sx={{ display: 'flex',}} >
        <CssBaseline />

          {/* Top Bar with background color #4a90e2 */}
          <Box>
          <AppBar position="fixed" open={open} sx={{  backgroundColor: layoutConfigData[0].backgroundColor}}>
            <Toolbar
              sx={{
                pr: '20px', // keep right padding when drawer closed
                
              }}
              style={{minHeight: `${layoutConfigData[0].minHeight}vh`, maxHeight: `${layoutConfigData[0].minHeight}vh`}}
              
            >
              {/* Toggle Drawer */}
              <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                onClick={toggleDrawer}
                onContextMenu={(e) => {
                  e.preventDefault();
                  handleToggleMinimize();
                }}
                sx={{
                  marginRight: '36px',
                  ...(open && { display: 'none' }),
                }}
              >
                <MenuIcon />
              </IconButton>


              {/* Logo Image */}
              <Box
                sx={{
                  width: '10vw', // Outer Box width as a percentage of viewport width
                  minHeight: `${layoutConfigData[0].minHeight}vh`, // Outer Box minimum height
                  maxHeight: `${layoutConfigData[0].minHeight}vh`, // Outer Box maximum height
                  overflow: 'hidden', // Hide overflow content
                  //bgcolor: 'lightblue', // Background color of the Outer Box
                  mr: '1vw', // Margin-right of the Outer Box
                  display: 'flex', // Flexbox layout for centering
                  justifyContent: 'center', // Center content horizontally
                  alignItems: 'center', // Center content vertically
                }}
              >
                <Box
                  sx={{
                    width: `${layoutConfigData[1].minWidth}vw`, // Inner Box width as a percentage of viewport width
                    minHeight: `${layoutConfigData[1].minHeight}vh`, // Outer Box minimum height
                    maxHeight: `${layoutConfigData[1].minHeight}vh`, // Outer Box maximum height
                    ml: parseInt(layoutConfigData[1].ml), // Margin-left of the Inner Box
                    mr: parseInt(layoutConfigData[1].mr), // Margin-right of the Inner Box
                    mt: parseInt(layoutConfigData[1].mt), // Margin-top of the Inner Box
                    mb: parseInt(layoutConfigData[1].mb), // Margin-bottom of the Inner Box
                    display: 'flex', // Ensure flexbox layout for centering image
                    alignItems: 'center', // Center image vertically
                    justifyContent: 'center', // Center image horizontally
                    //bgcolor: 'black', // Background color of the Outer Box
                    overflow: 'hidden', // Hide any overflow content
                  }}
                >
                  {layoutConfigData?.[1]?.ComponentStatus === 'Enabled' && (
                    <Tooltip title="Logo">
                      <span>
                      <img
                        src={logo}
                        alt="Logo"
                        style={{
                          width: '100%', // Image width to fill the Inner Box
                          height: '100%', // Image height to fill the Inner Box
                          objectFit: 'contain', // Maintain aspect ratio and fit within the Inner Box
                          //maxWidth: '100%', // Ensure the image does not exceed Inner Box width
                          //maxHeight: '100%', // Ensure the image does not exceed Inner Box height
                          display: 'block', // Ensure no extra space around the image
                        }}
                      />
                      </span>
                    </Tooltip>
                  )}
                </Box>
              </Box>

              {/* Project Description */}
              <Box
                sx={{
                  ml: '5vw',
                  width: '65vw', // Outer Box width as a percentage of viewport width
                  minHeight: `${layoutConfigData[0].minHeight}vh`, // Outer Box minimum height
                  maxHeight: `${layoutConfigData[0].minHeight}vh`, // Outer Box maximum height
                  overflow: 'hidden', // Hide overflow content
                  //bgcolor: 'lightblue', // Background color of the Outer Box
                  mr: '1vw', // Margin-right of the Outer Box
                  display: 'flex', // Flexbox layout for centering
                  justifyContent: 'center', // Center content horizontally
                  alignItems: 'center', // Center content vertically
                }}
              >
                <Box
                  sx={{
                    width: `${layoutConfigData[2].minWidth}vw`, // Inner Box width as a percentage of viewport width
                    minHeight: `${layoutConfigData[2].minHeight}vh`, // Outer Box minimum height
                    maxHeight: `${layoutConfigData[2].minHeight}vh`, // Outer Box maximum height
                    ml: parseInt(layoutConfigData[2].ml), // Margin-left of the Inner Box
                    mr: parseInt(layoutConfigData[2].mr), // Margin-right of the Inner Box
                    mt: parseInt(layoutConfigData[2].mt), // Margin-top of the Inner Box
                    mb: parseInt(layoutConfigData[2].mb), // Margin-bottom of the Inner Box
                    display: 'flex', // Ensure flexbox layout for centering image
                    alignItems: 'center', // Center image vertically
                    justifyContent: 'center', // Center image horizontally
                    //bgcolor: 'black', // Background color of the Outer Box
                    overflow: 'hidden', // Hide any overflow content
                  }}
                >
                  {layoutConfigData?.[2]?.ComponentStatus === 'Enabled' &&(<ProjectDescription projectName = {selecetdProject} projectDescrprops = {projectDescrprops}/>)}

                </Box>
              </Box>           

              {/* Communication fail icon */}
              <Box
                sx={{
                  width: '4vw', // Outer Box width as a percentage of viewport width
                  minHeight: `${layoutConfigData[0].minHeight}vh`, // Outer Box minimum height
                  maxHeight: `${layoutConfigData[0].minHeight}vh`, // Outer Box maximum height
                  overflow: 'hidden', // Hide overflow content
                  //bgcolor: 'lightblue', // Background color of the Outer Box
                  mr: '1vw', // Margin-right of the Outer Box
                  display: 'flex', // Flexbox layout for centering
                  justifyContent: 'center', // Center content horizontally
                  alignItems: 'center', // Center content vertically
                }}
              >
                <Box
                  sx={{
                    width: `${layoutConfigData[3].minWidth}vw`, // Inner Box width as a percentage of viewport width
                    minHeight: `${layoutConfigData[3].minHeight}vh`, // Outer Box minimum height
                    maxHeight: `${layoutConfigData[3].minHeight}vh`, // Outer Box maximum height
                    ml: parseInt(layoutConfigData[3].ml), // Margin-left of the Inner Box
                    mr: parseInt(layoutConfigData[3].mr), // Margin-right of the Inner Box
                    mt: parseInt(layoutConfigData[3].mt), // Margin-top of the Inner Box
                    mb: parseInt(layoutConfigData[3].mb), // Margin-bottom of the Inner Box
                    display: 'flex', // Ensure flexbox layout for centering image
                    alignItems: 'center', // Center image vertically
                    justifyContent: 'center', // Center image horizontally
                    //bgcolor: 'black', // Background color of the Outer Box
                    overflow: 'hidden', // Hide any overflow content
                  }}
                >
                  {layoutConfigData?.[3]?.ComponentStatus === 'Enabled' &&(<Tooltip title="Communication Fail">
                    <span>
                    <IconButton  
                      color="inherit" 
                      onClick={() => handleComponentSelection(componentList[4])}
                      sx={{ ml: parseInt(layoutConfigData[3].ml), mr: parseInt(layoutConfigData[3].mr), mt: parseInt(layoutConfigData[3].mt), mb: parseInt(layoutConfigData[3].mb),}}
                    >
                      <Badge badgeContent={liveAlarmCount} color="error"> {/* Avaialabe options are primary, secondary, success, error or for custom color use sx={{color: "red"}} etc*/}
                        <LinkOffIcon />
                      </Badge>
                    </IconButton>
                    </span>
                  </Tooltip >)}

                </Box>
              </Box>

              {/* Alarm Icon */}
              <Box
                sx={{
                  width: '4vw', // Outer Box width as a percentage of viewport width
                  minHeight: `${layoutConfigData[0].minHeight}vh`, // Outer Box minimum height
                  maxHeight: `${layoutConfigData[0].minHeight}vh`, // Outer Box maximum height
                  overflow: 'hidden', // Hide overflow content
                  //bgcolor: 'lightblue', // Background color of the Outer Box
                  mr: '1vw', // Margin-right of the Outer Box
                  display: 'flex', // Flexbox layout for centering
                  justifyContent: 'center', // Center content horizontally
                  alignItems: 'center', // Center content vertically
                }}
              >
                <Box
                  sx={{
                    width: `${layoutConfigData[4].minWidth}vw`, // Inner Box width as a percentage of viewport width
                    minHeight: `${layoutConfigData[4].minHeight}vh`, // Outer Box minimum height
                    maxHeight: `${layoutConfigData[4].minHeight}vh`, // Outer Box maximum height
                    ml: parseInt(layoutConfigData[4].ml), // Margin-left of the Inner Box
                    mr: parseInt(layoutConfigData[4].mr), // Margin-right of the Inner Box
                    mt: parseInt(layoutConfigData[4].mt), // Margin-top of the Inner Box
                    mb: parseInt(layoutConfigData[4].mb), // Margin-bottom of the Inner Box
                    display: 'flex', // Ensure flexbox layout for centering image
                    alignItems: 'center', // Center image vertically
                    justifyContent: 'center', // Center image horizontally
                    //bgcolor: 'black', // Background color of the Outer Box
                    overflow: 'hidden', // Hide any overflow content
                  }}
                >
                  {(layoutConfigData?.[4]?.ComponentStatus === 'Enabled' && liveAlarmCount === 0) && (
                
                    <IconButton 
                    color="inherit" 
                    onClick={() => handleComponentSelection(componentList[4])} 
                    sx={{ ml: parseInt(layoutConfigData[4].ml), mr: parseInt(layoutConfigData[4].mr), mt: parseInt(layoutConfigData[4].mt), mb: parseInt(layoutConfigData[4].mb),}}
                    >
                      <Badge badgeContent={liveAlarmCount} color="secondary">
                        <NotificationsIcon color="primary"/>
                      </Badge>
                    </IconButton>
                  
                  )}

                  {(layoutConfigData?.[4]?.ComponentStatus === 'Enabled' && liveAlarmCount >= 1) && (
                    <Tooltip title="Live Alarms">
                      <span>
                      <IconButton 
                      color="inherit" 
                      onClick={() => handleComponentSelection(componentList[4])} 
                      sx={{ ml: parseInt(layoutConfigData[4].ml), mr: parseInt(layoutConfigData[4].mr), mt: parseInt(layoutConfigData[4].mt), mb: parseInt(layoutConfigData[4].mb),}}
                      >
                        <Badge badgeContent={liveAlarmCount} color="error"> {/* Avaialabe options are primary, secondary, success, error or for custom color use sx={{color: "red"}} etc*/}
                          <NotificationsActiveIcon />
                        </Badge>
                      </IconButton>
                      </span>
                    </Tooltip >
                  )}
                </Box>
              </Box>

              {/* Date Time Display */}
              
              {(layoutConfigData?.[8]?.ComponentStatus === 'Enabled' &&
              <Box
                sx={{
                  width: '10vw', // Outer Box width as a percentage of viewport width
                  minHeight: `${layoutConfigData[0].minHeight}vh`, // Outer Box minimum height
                  maxHeight: `${layoutConfigData[0].minHeight}vh`, // Outer Box maximum height
                  overflow: 'hidden', // Hide overflow content
                  //bgcolor: 'lightblue', // Background color of the Outer Box
                  ml: '1vw', // Margin-right of the Outer Box
                  display: 'flex', // Flexbox layout for centering
                  justifyContent: 'center', // Center content horizontally
                  alignItems: 'center', // Center content vertically
                }}
                >
                
                <Grid item xs={4}> <DateTimeDisplay/>  </Grid>
                
              </Box>
              )}

              {/* Profile Icon When user Login page is enabled*/}
              {(loginScreenStatus === 'Enabled') && (
              <Box
                sx={{
                  width: '5vw', // Outer Box width as a percentage of viewport width
                  minHeight: `${layoutConfigData[0].minHeight}vh`, // Outer Box minimum height
                  maxHeight: `${layoutConfigData[0].minHeight}vh`, // Outer Box maximum height
                  overflow: 'hidden', // Hide overflow content
                  //bgcolor: 'lightblue', // Background color of the Outer Box
                  mr: '1vw', // Margin-right of the Outer Box
                  display: 'flex', // Flexbox layout for centering
                  justifyContent: 'center', // Center content horizontally
                  alignItems: 'center', // Center content vertically
                }}
              >
                <Box
                  sx={{
                    width: `${layoutConfigData[5].minWidth}vw`, // Inner Box width as a percentage of viewport width
                    minHeight: `${layoutConfigData[5].minHeight}vh`, // Outer Box minimum height
                    maxHeight: `${layoutConfigData[5].minHeight}vh`, // Outer Box maximum height
                    ml: parseInt(layoutConfigData[5].ml), // Margin-left of the Inner Box
                    mr: parseInt(layoutConfigData[5].mr), // Margin-right of the Inner Box
                    mt: parseInt(layoutConfigData[5].mt), // Margin-top of the Inner Box
                    mb: parseInt(layoutConfigData[5].mb), // Margin-bottom of the Inner Box
                    display: 'flex', // Ensure flexbox layout for centering image
                    alignItems: 'center', // Center image vertically
                    justifyContent: 'center', // Center image horizontally
                    //bgcolor: 'black', // Background color of the Outer Box
                    overflow: 'hidden', // Hide any overflow content
                  }}
                >
                  {layoutConfigData?.[5]?.ComponentStatus === 'Enabled' && (<ProfileMenu/>)}
                </Box>
              </Box>
              )}

              {/* Login/Logout Icon When user Login page is disabled, direct app opening without login*/}
              {(loginScreenStatus !== 'Enabled') && (
              <Box
                sx={{
                  width: '5vw', // Outer Box width as a percentage of viewport width
                  minHeight: `${layoutConfigData[0].minHeight}vh`, // Outer Box minimum height
                  maxHeight: `${layoutConfigData[0].minHeight}vh`, // Outer Box maximum height
                  overflow: 'hidden', // Hide overflow content
                  //bgcolor: 'lightblue', // Background color of the Outer Box
                  mr: '1vw', // Margin-right of the Outer Box
                  display: 'flex', // Flexbox layout for centering
                  justifyContent: 'center', // Center content horizontally
                  alignItems: 'center', // Center content vertically
                }}
              >
                <Box
                  sx={{
                    width: `${layoutConfigData[5].minWidth}vw`, // Inner Box width as a percentage of viewport width
                    minHeight: `${layoutConfigData[5].minHeight}vh`, // Outer Box minimum height
                    maxHeight: `${layoutConfigData[5].minHeight}vh`, // Outer Box maximum height
                    ml: parseInt(layoutConfigData[5].ml), // Margin-left of the Inner Box
                    mr: parseInt(layoutConfigData[5].mr), // Margin-right of the Inner Box
                    mt: parseInt(layoutConfigData[5].mt), // Margin-top of the Inner Box
                    mb: parseInt(layoutConfigData[5].mb), // Margin-bottom of the Inner Box
                    display: 'flex', // Ensure flexbox layout for centering image
                    alignItems: 'center', // Center image vertically
                    justifyContent: 'center', // Center image horizontally
                    //bgcolor: 'black', // Background color of the Outer Box
                    overflow: 'hidden', // Hide any overflow content
                  }}
                >
                  {layoutConfigData?.[5]?.ComponentStatus === 'Enabled' && (<LoginLogoutMenu/>)}
                </Box>
              </Box>
              )}

            </Toolbar>
          </AppBar>
          </Box>

          {/* Drawer for menu items*/}
          <Drawer 
          variant="permanent" 
          open={open} 
          hidden={hidden} // Pass the drawerWidth prop here
          >
            <Toolbar
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                px: [1],
                
                
              }}
              style={{minHeight: `${layoutConfigData[0].minHeight}vh`,}}
            >
              <IconButton 
              onClick={toggleDrawer}
              onContextMenu={(e) => {
                e.preventDefault();
                handleToggleMinimize();
              }}
              >
                {layoutConfigData?.[6]?.ComponentStatus === 'Enabled' && (
                  <a
                    style={{
                      backgroundColor: layoutConfigData[6].backgroundColor,
                      fontSize: parseInt(layoutConfigData[6].fontSize),
                      fontWeight: parseInt(layoutConfigData[6].fontWeight),
                      color: layoutConfigData[6].textColor
                    }}
                  >
                    {user.companyname || 'Radix'}
                  </a>
                )}

                <ChevronLeftIcon/>
              </IconButton>

            </Toolbar>
            <Divider />
            <Box
              sx={{
                //width: "100%",
                height: "90vh",
                overflowY: "auto", // Enable vertical scrolling
                overflowX: "hidden", // Disable horizontal scrolling
              }}
            >
              <List component="nav" >
                {((licenseStatus && (keyStatus === "Active" || keyStatus === "Invalid License Key")) 
                && (isDashboardViewAccess || user.role === "superadmin" || user.role === "engineer"))
                && (
                  <Tooltip title="Mimic View" placement="right">
                  <ListItemButton onClick={() => handleComponentSelection(componentList[1])}>
                    <ListItemIcon>
                      <DashboardIcon style={{ color: '#6b6b6bff' }}/>
                    </ListItemIcon>
                    <ListItemText primary= "Mimic View" />
                  </ListItemButton>
                  </Tooltip>
                )}

                {((licenseStatus && (keyStatus === "Active" || keyStatus === "Invalid License Key")) 
                 && (isTableViewAccess || user.role === "superadmin" || user.role === "engineer")) 
                 && (
                  <Tooltip title="Table View" placement="right">
                  <ListItemButton onClick={() => handleComponentSelection(componentList[2])}>
                    <ListItemIcon>
                      <TableViewIcon style={{ color: '#00897b' }}/>
                    </ListItemIcon>
                    <ListItemText primary= "Table View" />
                  </ListItemButton>
                  </Tooltip>
                )}
                
                {((licenseStatus && (keyStatus === "Active" || keyStatus === "Invalid License Key")) 
                 && (isRecipeViewAccess || user.role === "superadmin" || user.role === "engineer")) 
                 && (
                  <Tooltip title="Recipe View" placement="right">
                  <ListItemButton onClick={() => handleComponentSelection(componentList[23])}>
                    <ListItemIcon>
                      <LibraryBooksRoundedIcon style={{ color: '#00897b' }}/>
                    </ListItemIcon>
                    <ListItemText primary= "Recipe View" />
                  </ListItemButton>
                  </Tooltip>
                )}

                {((licenseStatus && (keyStatus === "Active" || keyStatus === "Invalid License Key")) 
                 && (isBatchDataAccess || user.role === "superadmin" || user.role === "engineer")) 
                 && (
                  <Tooltip title="Batch Data" placement="right">
                  <ListItemButton onClick={() => handleComponentSelection(componentList[24])}>
                    <ListItemIcon>
                      <BatchPredictionIcon style={{ color: '#00897b' }}/>
                    </ListItemIcon>
                    <ListItemText primary= "Batch Data" />
                  </ListItemButton>
                  </Tooltip>
                )}
                
                {((licenseStatus) && (isAlarmViewAccess || user.role === "superadmin" || user.role === "engineer")) && (
                  <Tooltip title="Alarms" placement="right">
                  <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[4])}>
                    <ListItemIcon>
                    <NotificationsActiveIcon style={{ color: '#e23112ff' }}/>
                    </ListItemIcon>
                    <ListItemText primary="Alarms" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}


                {((licenseStatus) && (isTrendViewAccess || user.role === "superadmin" || user.role === "engineer")) && (
                  <Tooltip title="Trend View" placement="right">
                  <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[3])}>
                    <ListItemIcon>
                    <TimelineIcon style={{ color: '#00897b' }}/>
                    </ListItemIcon>
                    <ListItemText primary= "Trend View"/>
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}

                {((licenseStatus) && (isReportViewAccess || user.role === "superadmin" || user.role === "engineer")) && (
                  <Tooltip title="Reports" placement="right">
                    <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[5])}>
                    <ListItemIcon>
                      <AssessmentIcon style={{ color: '#00897b' }}/>
                    </ListItemIcon>
                    <ListItemText primary="Reports" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}

                {((licenseStatus) && (isReportViewWithReviewOption || user.role === "superadmin" || user.role === "engineer")) && (
                  <Tooltip title="Reports with Review" placement="right">
                    <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[6])}>
                    <ListItemIcon>
                      <AssessmentIcon style={{ color: '#00897b' }}/>
                    </ListItemIcon>
                    <ListItemText primary="Reports with Review" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}

                {(((licenseStatus && (keyStatus === "Active" || keyStatus === "Invalid License Key")) 
                 && (isUserMgmtViewAccess || user.role === "superadmin" || user.role === "engineer") 
                 && (user.role !== "visitor" && user.role !== "operator")) ) && (
                  <Tooltip title="User Management" placement="right">
                  <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[7])}>
                    <ListItemIcon>
                      <ManageAccountsIcon style={{ color: '#00897b' }}/>
                    </ListItemIcon>
                    <ListItemText primary="User Management" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}

                {((licenseStatus) && (isAuditTrailViewAccess || user.role === "superadmin" || user.role === "engineer")) && (
                  <Tooltip title="AuditTrail" placement="right">
                  <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[8])}>
                    <ListItemIcon>
                    <img src={AuditTrail} alt="Custom Icon" style={{ width: 24, height: 24 }} />
                    </ListItemIcon>
                    <ListItemText primary="AuditTrail" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}

                {((licenseType === "Development" && licenseStatus === true && keyStatus === "Active") && (isDataBackupViewAccess || user.role === "superadmin" || user.role === "engineer")) && (
                  <Tooltip title="Data Backup" placement="right">
                  <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[9])}>
                    <ListItemIcon>
                    <ContentCopyIcon style={{ color: '#00897b' }}/>
                    </ListItemIcon>
                    <ListItemText primary="Data Backup" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}
                

                {((licenseType === "Development" && licenseStatus === true && keyStatus === "Active") && (isDataRestoreViewAccess || user.role === "superadmin" || user.role === "engineer")) && (
                  <Tooltip title="Data Restore" placement="right">
                  <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[10])}>
                    <ListItemIcon>
                    <RestoreIcon style={{ color: '#00897b' }}/>
                    </ListItemIcon>
                    <ListItemText primary="Data Restore" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}


                {((licenseType === "Development" && licenseStatus === true && keyStatus === "Active") && (isHistDataEditorViewAccess || user.role === "superadmin" || user.role === "engineer")) && (
                  <Tooltip title="Historical Data Viewer" placement="right">
                    <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[11])}>
                    <ListItemIcon>
                    <SaveAsIcon style={{ color: '#00897b' }}/>
                    </ListItemIcon>
                    <ListItemText primary="Hist Data Viewer" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}

                {/* {((licenseType === "Development" && licenseStatus === true && keyStatus === "Active") && (isEmailViewAccess || user.role === "superadmin" || user.role === "engineer")) && (
                  <Tooltip title="Email" placement="right">
                  <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[12])}>
                    <ListItemIcon>
                    <MailIcon style={{ color: '#6b6b6bff' }}/>
                    </ListItemIcon>
                    <ListItemText primary="Email Configuration" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )} */}

                {/* {((licenseType === "Development" && licenseStatus === true && keyStatus === "Active") && (isSMSViewAccess || user.role === "superadmin" || user.role === "engineer")) && (
                  <Tooltip title="SMS" placement="right">
                  <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[13])}>
                    <ListItemIcon>
                    <SmsIcon style={{ color: '#6b6b6bff' }}/>
                    </ListItemIcon>
                    <ListItemText primary="SMS Configuration" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )} */}

                {(
                (licenseType === "Development" ) &&
                licenseStatus === true &&
                (user.role === "superadmin" || user.role === "engineer")
                ) && (
                  <Tooltip title="System Configurations" placement="right">
                  <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[14])}>
                    <ListItemIcon>
                      <SettingsIcon style={{ color: '#00897b' }}/>
                    </ListItemIcon>
                    <ListItemText primary="System Configurations" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}

                {((licenseType === "Development" && licenseStatus === true && keyStatus === "Active") && (isFtpServerViewAccess || user.role === "superadmin" || user.role === "engineer")) && (
                  <Tooltip title="FTP Server Settings" placement="right">
                    <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[15])}>
                    <ListItemIcon>
                    <img src={FTPServerIcon} alt="Custom Icon" style={{ width: 24, height: 30, color: '#00897b'}} />
                    </ListItemIcon>
                    <ListItemText primary="FTP Server Settings" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}

                {((licenseType === "Development" && licenseStatus === true && keyStatus === "Active") && (isFtpClientViewAccess || user.role === "superadmin" || user.role === "engineer")) && (
                  
                  <Tooltip title="FTP Client Settings" placement="right">
                    <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[16])}>
                    <ListItemIcon>
                    
                    <img src={FTPClientIcon} alt="Custom Icon" style={{ width: 24, height: 30, color: '#00897b'}} />
                    </ListItemIcon>
                    <ListItemText primary="FTP Client Settings" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}             

                {((licenseType === "Development" && licenseStatus === true && keyStatus === "Active") && (isAppDataEditorViewAccess || user.role === "superadmin" || user.role === "engineer")) && (
                  <Tooltip title="Application Data Editor" placement="right">
                    <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[17])}>
                    <ListItemIcon>
                    <FileCopyIcon style={{ color: '#00897b' }}/>
                    </ListItemIcon>
                    <ListItemText primary="Application Data Editor" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}

                {(isLicenseConfiguratorViewAccess || user.role === "superadmin" || user.role === "engineer") && (
                  <Tooltip title="Activation" placement="right">
                    <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[18])}>
                    <ListItemIcon>
                    <VpnKeyIcon style={{ color: '#a6e7e0ff' }}/>
                    </ListItemIcon>
                    <ListItemText primary="Activation" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}


                {(user.role === "engineer" || user.role === "superadmin") && (
                  <Tooltip title="User guide" placement="right">
                    <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[19])}>
                    <ListItemIcon>
                    <LiveHelpOutlinedIcon style={{ color: '#6b6b6bff' }}/>
                    </ListItemIcon>
                    <ListItemText primary="User guide" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}

                {(user.role === "engineer" || user.role === "superadmin") && (
                  <Tooltip title="Engineering Guide" placement="right">
                    <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[20])}>
                    <ListItemIcon>
                    <InstallDesktopIcon style={{ color: '#6b6b6bff' }}/>
                    </ListItemIcon>
                    <ListItemText primary="Engineering Guide" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}

                {(user.role === "superadmin") && (
                  <Tooltip title="Installation Guide" placement="right">
                    <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[21])}>
                    <ListItemIcon>
                    <EngineeringIcon style={{ color: '#6b6b6bff'}}/>
                    </ListItemIcon>
                    <ListItemText primary="Installation Guide" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}

                {(user.role === "engineer" || user.role === "superadmin") && (
                  <Tooltip title="Download Center" placement="right">
                    <span>
                  <ListItemButton onClick={() => handleComponentSelection(componentList[22])}>
                    <ListItemIcon>
                    <FileDownloadIcon style={{ color: '#6b6b6bff' }}/>
                    </ListItemIcon>
                    <ListItemText primary="Download Center" />
                  </ListItemButton>
                  </span>
                  </Tooltip>
                )}

              {/* {mainListItems} */}
                <Divider sx={{ my: 1 }} />
                {/*  {secondaryListItems}  */}
              </List> 
            </Box>
          </Drawer>

          {/* Main Container to display the data and widgets */}
          <Box
            component="main"
            sx={{ backgroundColor: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[100]
                  : theme.palette.grey[900],
              flexGrow: 1,
              height: `${100 - parseInt(layoutConfigData[0].minHeight)}vh`,
              overflow: 'auto',
              mt:`${layoutConfigData[0].minHeight}vh`,           
            }}

            
          >
            {/* Display welocme screen or  menu item of drawer*/}
              {selectedComponent} 

            {/* Bottom bar/ Copy right bar*/}
            <Copyright sx={{ pt: 1}} />         

          </Box>


      </Box>

      {user.email !== "visitor@gmail.com" && (
        <IdleTimeout timeout={timeOutSP} onLogout={handleLogout} />
      )}
      
    </ThemeProvider>
    
  );

}